const btn = document.getElementById('closeAccordion');
const initialBlock = document.querySelector('.split-menu-img-block');
const accordionBlock = document.querySelector('.wp-block-ume-ume-accordion-holder');


if(initialBlock && accordionBlock && btn){
    btn.addEventListener('click', function (){
       accordionBlock.style.display = 'none';
       initialBlock.style.display = 'block';

       let positionToViewport = initialBlock.getBoundingClientRect().top;

       if(positionToViewport < 0){
           setTimeout(() => { window.scrollBy(0, positionToViewport - 200) }, 500);
       }

    });
}

